import omitBy from 'lodash.omitby'
import { useCallback, useMemo } from 'react'

import { AuthStateCache, useAuth } from 'src/providers/AuthProvider'

import { RemoveIndex } from 'src/types/common'

export const useCache = <
  K extends keyof RemoveIndex<AuthStateCache>,
  T = AuthStateCache[K]
>({
  key
}: {
  key: K
}) => {
  const { cache, setCache } = useAuth()

  const value = useMemo(() => {
    return cache?.[key] as T
  }, [cache, key])

  const setValue = useCallback(
    (val?: T) => {
      let cacheToSet = { ...cache }
      if (val) {
        // filter out form empty string initial values so reinitialisation from the cache doesn't trigger form dirty states / validation,
        // then set cache value by key
        cacheToSet = {
          ...cache,
          [key]: omitBy(val as object, v => v === '') as T
        }
      } else {
        delete cacheToSet[key]
      }

      setCache(cacheToSet)
    },
    [cache, setCache, key]
  )

  return { value, setValue }
}
